import * as Yup from 'yup'
export const initialValues = (addressData = {}, customer = {}) => {
    return {
        address_type: addressData.address_type || "",
        shipping_first_name: addressData.shipping_first_name || (customer.first_name || ""),
        shipping_middle_name: addressData.shipping_middle_name || (customer.middle_name || ""),
        shipping_last_name: addressData.shipping_last_name || (customer.last_name || ""),
        shipping_company_name: addressData.shipping_company_name || (customer.company_name || ""),
        shipping_address: addressData.shipping_address || "",
        shipping_address1: addressData.shipping_address1 || "",
        shipping_city: addressData.shipping_city || "",
        shipping_country: addressData.shipping_country || "",
        shipping_state: addressData.shipping_state || "",
        shipping_zipcode: addressData.shipping_zipcode || "",
        shipping_phone: addressData.shipping_phone || "",
        shipping_mobile: addressData.shipping_mobile || "",
        shipping_fax: addressData.shipping_fax || "",
        address_id: addressData.address_id || ""
    }

}

export const createCustomerFormValidationSchema = Yup.object({
    address_type: Yup.string().required('This field is required'),
    shipping_first_name: Yup.string().required('This field is required'),
    shipping_last_name: Yup.string().required('This field is required'),
    shipping_address: Yup.string().required('This field is required'),
    shipping_city: Yup.string().required('This field is required'),
    shipping_state: Yup.string().required('This field is required'),
    shipping_country: Yup.string().required('This field is required'),
    shipping_mobile: Yup.string()
        .required("This field is required")
        .min(8, 'Invalid number')
        .max(12, 'Invalid number')
})
